export function String_extractIndex(str: string): number | null {
    if (!str || typeof str !== "string") {
        return null;
    }

    const match = str.match(/\[(\d+)\]/);
    return match ? parseInt(match[1], 10) : null;
}

export function String_deCapitalize(str: string): string {
    if (!str || typeof str !== "string") {
        return str;
    }

    if (str.length === 1) {
        return str[0].toLocaleLowerCase();
    }

    const result = str[0].toLocaleLowerCase() + str.substring(1);
    return result;
}

export function String_capitalize(str: string): string {
    if (!str || typeof str !== "string") {
        return str;
    }

    if (str.length === 1) {
        return str[0].toLocaleUpperCase();
    }

    const result = str[0].toLocaleUpperCase() + str.substring(1);
    return result;
}

export function String_removePrefix(str: string, prefix: string): string {
    if (!str || !prefix || typeof str !== "string" || typeof prefix !== "string" || !str.startsWith(prefix)) {
        return str;
    }

    return str.substring(prefix.length);
}

export function String_base64StringToBlob(base64String: string): Blob {
    const [prefix, content] = base64String.split(";base64,");
    const contentType = prefix.split(":")[1];

    const decodedContent = atob(content);

    const uInt8Array = new Uint8Array(decodedContent.length);

    for (let i = 0; i < uInt8Array.length; i++) {
        uInt8Array[i] = decodedContent.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
}

export function String_timeStringIsValid(timeString: string): boolean {
    const splitTime = timeString.split(":");
    if (splitTime.length !== 2) {
        return false;
    }

    const hours = Number.parseInt(splitTime[0]);
    const minutes = Number.parseInt(splitTime[1]);

    return !Number.isNaN(hours) && !Number.isNaN(minutes) && hours >= 0 && hours < 24 && minutes >= 0 && minutes < 60;
}
